var map = {
	"./views/FourSoS/4SoS.vue": [
		1882,
		1882
	],
	"./views/FourSoS/4SoSWhiteRollCall.vue": [
		50074,
		74
	],
	"./views/TumbleRadar/Radar.vue": [
		92946,
		968,
		2946
	],
	"./views/TumbleRadar/newRadar2024.vue": [
		7123,
		968,
		7123
	],
	"./views/TumbleRadar/radar_chitongda_Jiangxichangtian.vue": [
		49155,
		968,
		9155
	],
	"./views/activity/activity_calendar.vue": [
		52945,
		2945
	],
	"./views/activity/activity_in_statistics.vue": [
		82561,
		2561
	],
	"./views/activity/activity_manager.vue": [
		31059,
		1059
	],
	"./views/activity/activity_satisfaction.vue": [
		22650,
		2650
	],
	"./views/activity/activity_statistics.vue": [
		42284,
		2284
	],
	"./views/activity/activity_summary.vue": [
		72699,
		2699
	],
	"./views/activity/activity_type.vue": [
		13773,
		3773
	],
	"./views/activity/scoring_approval.vue": [
		70882,
		882
	],
	"./views/activity/sign_up.vue": [
		92131,
		2131
	],
	"./views/activity/volunteer_manager.vue": [
		1482,
		1482
	],
	"./views/aged/aged_ability.vue": [
		63895,
		3895
	],
	"./views/aged/aged_category.vue": [
		52434,
		2434
	],
	"./views/aged/aged_death.vue": [
		35253,
		5253
	],
	"./views/aged/aged_delivery.vue": [
		75121,
		5121
	],
	"./views/aged/aged_detail.vue": [
		97624
	],
	"./views/aged/aged_disability.vue": [
		22957,
		2957
	],
	"./views/aged/aged_record.vue": [
		88179,
		8179
	],
	"./views/aged/aged_record_abnormal_dw.vue": [
		64353,
		4353
	],
	"./views/aged/aged_record_abnormal_jiashu.vue": [
		91982,
		1982
	],
	"./views/aged/aged_record_abnormal_quhua.vue": [
		41080,
		1080
	],
	"./views/aged/aged_record_abnormal_sfz.vue": [
		58855,
		8855
	],
	"./views/aged/aged_residence.vue": [
		56268,
		6268
	],
	"./views/aged/health_record.vue": [
		29419,
		9419
	],
	"./views/aged/health_registration.vue": [
		71287,
		1287
	],
	"./views/ai/ai_evaluation_room_camera.vue": [
		40181,
		181
	],
	"./views/ai/ai_evaluation_table.vue": [
		8864,
		1481,
		6871
	],
	"./views/ai/ai_robot.vue": [
		53485,
		3485
	],
	"./views/ai/ai_znpgs.vue": [
		98485,
		3936,
		8485
	],
	"./views/ai/cameraPlay.vue": [
		60790,
		790
	],
	"./views/ai/deepseek.vue": [
		7743,
		7743
	],
	"./views/ai/health-assessment.vue": [
		12094,
		2094
	],
	"./views/aotong/aotong.vue": [
		67811,
		3169,
		9189,
		4431
	],
	"./views/aotong/full_screen.vue": [
		69133,
		9189,
		9133
	],
	"./views/aotong/report.vue": [
		31681,
		9189,
		1681
	],
	"./views/app/aged.vue": [
		57799,
		7799
	],
	"./views/app/assessment_pg.vue": [
		51586,
		1586
	],
	"./views/app/index.vue": [
		22149,
		2149
	],
	"./views/app/indexXcx.vue": [
		16868,
		6868
	],
	"./views/app/login.vue": [
		73719,
		3719
	],
	"./views/bank/BankStatement.vue": [
		36818,
		6818
	],
	"./views/basics/employee_manager.vue": [
		42954,
		2954
	],
	"./views/basics/provider_employee.vue": [
		84541,
		4541
	],
	"./views/basics/provider_manager.vue": [
		49519,
		9519
	],
	"./views/bdsxt/token.vue": [
		57465,
		1481,
		6506
	],
	"./views/bioland/Sphygmomanometer.vue": [
		77797,
		7797
	],
	"./views/bioland/glucometer.vue": [
		45164,
		5164
	],
	"./views/boshi/boshi.vue": [
		24444,
		4444
	],
	"./views/boshi/boshi_alarm.vue": [
		42248,
		2248
	],
	"./views/boshi/boshi_position_location.vue": [
		78981,
		8981
	],
	"./views/boshi/boshi_shoubiao.vue": [
		74241,
		4241
	],
	"./views/boshi/boshi_shouhuan.vue": [
		21360,
		1360
	],
	"./views/call/call_history.vue": [
		52881,
		2881
	],
	"./views/call/test.vue": [
		79412,
		9412
	],
	"./views/call/testHome.vue": [
		92835,
		2835
	],
	"./views/center/service/appendix.vue": [
		79054,
		9054
	],
	"./views/center/service/conduct.vue": [
		62472,
		2472
	],
	"./views/center/service/construction_already_examine.vue": [
		23544,
		3544
	],
	"./views/center/service/construction_civil.vue": [
		20450,
		450
	],
	"./views/center/service/construction_examine.vue": [
		19011,
		9011
	],
	"./views/center/service/construction_failed.vue": [
		19829,
		9829
	],
	"./views/center/service/daily_patrol.vue": [
		35194,
		5194
	],
	"./views/center/service/service_already_examine.vue": [
		3707,
		3707
	],
	"./views/center/service/service_civil.vue": [
		55537,
		5537
	],
	"./views/center/service/service_construction.vue": [
		26611,
		6611
	],
	"./views/center/service/service_examine.vue": [
		84085,
		4085
	],
	"./views/center/service/service_failed.vue": [
		55649,
		8030
	],
	"./views/center/service/service_wo.vue": [
		64506,
		4506
	],
	"./views/center/service/slh_aged.vue": [
		24846,
		4846
	],
	"./views/center/service/slh_aged_new.vue": [
		81167,
		1167
	],
	"./views/center/service/slh_qindan.vue": [
		99127,
		9127
	],
	"./views/center/service/slh_qindan_xining.vue": [
		43419,
		3419
	],
	"./views/center/wo/temp_workorder.vue": [
		18320,
		8320
	],
	"./views/center/wo/workorder_abnormal.vue": [
		50337,
		337
	],
	"./views/center/wo/workorder_content.vue": [
		33846,
		3846
	],
	"./views/center/wo/workorder_deleted.vue": [
		77341,
		7341
	],
	"./views/center/wo/workorder_manager.vue": [
		31413,
		1413
	],
	"./views/center/wo/workorder_manager_vc.vue": [
		80219,
		219
	],
	"./views/center/wo/workorder_nomv.vue": [
		26157,
		6157
	],
	"./views/center/wo/workorder_nopic.vue": [
		15009,
		5009
	],
	"./views/center/wo/workorder_overtime.vue": [
		40300,
		300
	],
	"./views/chiTongDaSleepRadar/ChiTongDaSleepRadar.vue": [
		76329,
		968,
		6329
	],
	"./views/crm/crm.vue": [
		2286,
		2286
	],
	"./views/crm/crm_push_content.vue": [
		21661,
		1661
	],
	"./views/device/device_matong.vue": [
		64453,
		4453
	],
	"./views/device/hdcs_simulator.vue": [
		75132,
		5132
	],
	"./views/device/hdcs_test.vue": [
		62391,
		2391
	],
	"./views/erweima/product.vue": [
		77781,
		7781
	],
	"./views/exam/ExamAnswersUser.vue": [
		70627,
		627
	],
	"./views/exam/ExamCategoriesSubjectStandard.vue": [
		28799,
		8799
	],
	"./views/exam/ExamPaper.vue": [
		7847,
		7847,
		5769
	],
	"./views/exam/ExamPaper_6.vue": [
		87301,
		7301
	],
	"./views/exam/ExamPaper_8.vue": [
		33402,
		3402
	],
	"./views/exam/ExamPapersUser.vue": [
		30264,
		264
	],
	"./views/exam/ExamQuestPaRelationStandard.vue": [
		33189,
		3189
	],
	"./views/exam/ExamQuestionsStandard.vue": [
		10816,
		816
	],
	"./views/exam/ExamQuestionsUser.vue": [
		94404,
		4404
	],
	"./views/exam/GameDemo.vue": [
		24134,
		1215,
		1527,
		6865,
		2976,
		1261,
		4134
	],
	"./views/exam/GameIndex.vue": [
		35942,
		1215,
		1527,
		6865,
		2976,
		1261,
		5942
	],
	"./views/exam/examAnswersStandard.vue": [
		39190,
		9190
	],
	"./views/exam/examIndex.vue": [
		7958,
		7847,
		7976
	],
	"./views/exam/examhome.vue": [
		19869,
		1215,
		1527,
		6865,
		2976,
		7847,
		1261,
		4357
	],
	"./views/exam/jiqirenui/CognitiveAssessment.vue": [
		1830,
		1215,
		1527,
		6865,
		2976,
		1830
	],
	"./views/exam/jiqirenui/CognitiveTraining.vue": [
		91153,
		1215,
		1527,
		6865,
		2976,
		1153
	],
	"./views/exam/jiqirenui/ScaleAssessment.vue": [
		94771,
		7847,
		1595
	],
	"./views/faceEquipment/FaceEquipment.vue": [
		29864,
		9864
	],
	"./views/faceEquipment/FaceEquipmentAged.vue": [
		41883,
		1883
	],
	"./views/geo/aged.vue": [
		93060,
		3060
	],
	"./views/geo/aiqiangua.vue": [
		11570,
		1570
	],
	"./views/geo/aiqiangua_chuangdai.vue": [
		74536,
		2155
	],
	"./views/geo/newAged.vue": [
		18994,
		8994
	],
	"./views/geo/yunxin_idCard.vue": [
		31977,
		1977
	],
	"./views/geo/yunxing_SoS.vue": [
		30944,
		944
	],
	"./views/gongdan/gaizhao.vue": [
		59163,
		9163
	],
	"./views/gongdan/gongdan.vue": [
		33839,
		3839
	],
	"./views/h5/my.vue": [
		25632,
		5632
	],
	"./views/h5/service.vue": [
		53950,
		3950
	],
	"./views/health/dispepHealthAbility.vue": [
		80193,
		193
	],
	"./views/health/healthAbility.vue": [
		22673,
		2673
	],
	"./views/health/healthPage-zhaoshang.vue": [
		71099,
		1099
	],
	"./views/health/healthPage.vue": [
		87681,
		7681
	],
	"./views/health/healthTransform.vue": [
		75794,
		5794
	],
	"./views/healthentiretyequipment/healthentiretyequipment.vue": [
		47215,
		7215
	],
	"./views/healthentiretyequipment/showHealthEquipment.vue": [
		63221,
		3221
	],
	"./views/hmp/healthDrugUse.vue": [
		21299,
		1299
	],
	"./views/hmp/healthRecord.vue": [
		29925,
		9925
	],
	"./views/hmp/healthRisk.vue": [
		15042,
		5042
	],
	"./views/hmp/tittleResult.vue": [
		78048,
		8048
	],
	"./views/home/home-new.vue": [
		41196
	],
	"./views/home/home-taihe.vue": [
		4654,
		4654
	],
	"./views/im/Age.vue": [
		37675,
		7675
	],
	"./views/im/Manage.vue": [
		10177,
		177
	],
	"./views/im/im.vue": [
		5379,
		5379
	],
	"./views/im/index.vue": [
		40020,
		9814,
		20
	],
	"./views/index.vue": [
		60709
	],
	"./views/institution/agedInstitution.vue": [
		79757,
		9757
	],
	"./views/institution/agedInstitutionAll.vue": [
		72088,
		832,
		1981
	],
	"./views/institution/amountName.vue": [
		59561,
		9561
	],
	"./views/institution/bed.vue": [
		30384,
		384
	],
	"./views/institution/bedAll.vue": [
		41392,
		1392
	],
	"./views/institution/byj.vue": [
		40493,
		832,
		1426
	],
	"./views/institution/catering.vue": [
		42918,
		2918
	],
	"./views/institution/electric.vue": [
		51003,
		1003
	],
	"./views/institution/nurse.vue": [
		47294,
		7294
	],
	"./views/institution/qt.vue": [
		2362,
		832,
		1983
	],
	"./views/institution/qtall.vue": [
		75279,
		832,
		1092
	],
	"./views/institution/rates.vue": [
		86113,
		6113
	],
	"./views/institution/wallet.vue": [
		31367,
		832,
		732
	],
	"./views/institution/wallettuizhu.vue": [
		8436,
		832,
		6241
	],
	"./views/institution/yjf.vue": [
		40018,
		832,
		4055
	],
	"./views/institution/yjfall.vue": [
		30251,
		832,
		8408
	],
	"./views/jingDa/jing_da.vue": [
		28443,
		8443
	],
	"./views/jituan/aged_record.vue": [
		79797,
		9797
	],
	"./views/jituan/healthPage.vue": [
		71511,
		1511
	],
	"./views/jituan/nbiot.vue": [
		56741,
		6741
	],
	"./views/jituan/slh_aged_new.vue": [
		39332,
		9332
	],
	"./views/k3/k3_goods.vue": [
		46035,
		6035
	],
	"./views/k3/k3_sale_order.vue": [
		97739,
		7739
	],
	"./views/kasn/kacard.vue": [
		91247,
		1247
	],
	"./views/kasn/kacarddevice.vue": [
		21180,
		1180
	],
	"./views/kasn/kacardother.vue": [
		12186,
		2186
	],
	"./views/kasn/kamessage.vue": [
		77130,
		7130
	],
	"./views/kasn/kamessagedevice.vue": [
		75726,
		5726
	],
	"./views/kasn/kamessageother.vue": [
		53343,
		3343
	],
	"./views/kasn/kasn.vue": [
		17223,
		7223
	],
	"./views/kasn/kasnshitu.vue": [
		69686,
		4631,
		9686
	],
	"./views/kasn/kasnshituIpad.vue": [
		91524,
		4631,
		1524
	],
	"./views/kasn/kasnshituwlyly.vue": [
		79304,
		4631,
		9304
	],
	"./views/kasn/kasnshituzhanhui.vue": [
		37318,
		4631,
		7318
	],
	"./views/lifeRader/life.vue": [
		93610,
		3610
	],
	"./views/login.vue": [
		59811
	],
	"./views/login2.vue": [
		78467,
		8467
	],
	"./views/medicine_box/MedicineBox.vue": [
		32288,
		2288
	],
	"./views/mingzhen/aged_up.vue": [
		9856,
		9856
	],
	"./views/mingzhen/haikou/aged_up.vue": [
		71814,
		1814
	],
	"./views/mingzhen/haikou/chuangdai.vue": [
		62210,
		2210
	],
	"./views/mingzhen/haikou/em_up.vue": [
		57553,
		7553
	],
	"./views/mingzhen/haikou/nbiot_event_up.vue": [
		92202,
		2202
	],
	"./views/mingzhen/haikou/wg.vue": [
		28954,
		8954
	],
	"./views/mingzhen/haikou/workorder_up.vue": [
		91697,
		1697
	],
	"./views/mingzhen/jianguan/aged_record.vue": [
		67491,
		7491
	],
	"./views/mingzhen/jianguan/huanjinjiancha.vue": [
		55409,
		5409
	],
	"./views/mingzhen/jianguan/report_aged_service_count.vue": [
		18030,
		5649
	],
	"./views/mingzhen/jianguan/report_aged_service_time.vue": [
		65892,
		5892
	],
	"./views/mingzhen/jianguan/slh_aged.vue": [
		41016,
		1016
	],
	"./views/mingzhen/jianguan/slh_qindan_xining.vue": [
		51484,
		1484
	],
	"./views/mingzhen/jianguan/taihe_gzgc.vue": [
		38381,
		8381
	],
	"./views/mingzhen/jianguan/tanshi_zhoufang.vue": [
		84092,
		4092
	],
	"./views/mingzhen/jianguan/workorder_manager.vue": [
		8744,
		8744
	],
	"./views/mingzhen/jianguan/workorder_manager_old.vue": [
		81448,
		1448
	],
	"./views/mingzhen/jianguan/yewu_zonglan.vue": [
		47158,
		7158
	],
	"./views/mingzhen/jianguan/zijin_bofu.vue": [
		22305,
		4686
	],
	"./views/mingzhen/jianguan/zijinbofu_zonglan.vue": [
		2338,
		2338
	],
	"./views/mingzhen/jianguan/ziliao_shenhe.vue": [
		1170,
		1170
	],
	"./views/mingzhen/luo_long_workorder_up.vue": [
		23614,
		3614
	],
	"./views/mingzhen/luo_yang_alarm_push.vue": [
		23802,
		3802
	],
	"./views/mingzhen/wg.vue": [
		54204,
		4204
	],
	"./views/mingzhen/workorder_up.vue": [
		2633,
		2633
	],
	"./views/mingzhen/xi_ning_workorder_up.vue": [
		60104,
		104
	],
	"./views/mingzhen/yang_quan_up.vue": [
		59920,
		9920
	],
	"./views/mingzhen/zsb.vue": [
		80973,
		973
	],
	"./views/monitor/camera_h5.vue": [
		95168,
		3936,
		5168
	],
	"./views/monitor/camera_manager.vue": [
		64983,
		3936,
		4983
	],
	"./views/monitor/camera_manager_jiqiren.vue": [
		46550,
		3936,
		6550
	],
	"./views/monitor/camera_web.vue": [
		74453,
		3936,
		6834
	],
	"./views/monitor/chuangdai.vue": [
		55111,
		5111
	],
	"./views/monitor/monitor_map.vue": [
		10326,
		326
	],
	"./views/monitor/monitor_map1.vue": [
		88346,
		8346
	],
	"./views/monitor/robot_patrol_record_z.vue": [
		48762,
		8762
	],
	"./views/monitor/robot_patrol_record_z_v2.vue": [
		98018,
		8018
	],
	"./views/monitor/robot_web.vue": [
		47904,
		3936,
		7904
	],
	"./views/nbiot/device_aqg.vue": [
		87282,
		7282
	],
	"./views/nbiot/journal_record.vue": [
		75883,
		8264
	],
	"./views/nbiot/nbiot.vue": [
		74386,
		4386
	],
	"./views/nbiot/nbiotHaiMan.vue": [
		21774,
		1774
	],
	"./views/nbiot/nbiot_event.vue": [
		61294,
		1294
	],
	"./views/nursingSupervision/nurse_grouping.vue": [
		72560,
		2560
	],
	"./views/nursingSupervision/nurse_monthly_schedule.vue": [
		81013,
		1013
	],
	"./views/pingantong/pingantong.vue": [
		66071,
		6071
	],
	"./views/pinggu/huanjing.vue": [
		48282,
		8282
	],
	"./views/qinglanradar/multifunctionRadarStart.vue": [
		84785,
		4785
	],
	"./views/qinglanradar/qinglanradar.vue": [
		60415,
		415
	],
	"./views/rabar_side_install/raderSideInstall.vue": [
		60963,
		963
	],
	"./views/report/aged/slh_aged_pg_wx.vue": [
		45826,
		5826
	],
	"./views/report/aged/slh_aged_wx.vue": [
		7188,
		7188
	],
	"./views/report/aged/tfga.vue": [
		30942,
		942
	],
	"./views/report/aged/wechat_IdCard.vue": [
		30164,
		164
	],
	"./views/report/aged/wechat_TumbleRadar.vue": [
		35542,
		5542
	],
	"./views/report/aged/wechat_XingMai.vue": [
		32692,
		2692
	],
	"./views/report/aged/wechat_XueTangYi.vue": [
		90111,
		111
	],
	"./views/report/aged/wechat_XueYaYi.vue": [
		10397,
		397
	],
	"./views/report/aged/wechat_YunXinSOS.vue": [
		96432,
		6432
	],
	"./views/report/aged/wechat_accessControl.vue": [
		74443,
		4443
	],
	"./views/report/aged/wechat_agedDelivery.vue": [
		55883,
		5883
	],
	"./views/report/aged/wechat_agedResidence.vue": [
		39959,
		9959
	],
	"./views/report/aged/wechat_fourSoS_Phone.vue": [
		87184,
		7184
	],
	"./views/report/aged/wechat_healthAbility_img.vue": [
		32277,
		2277
	],
	"./views/report/aged/wechat_shouhuan.vue": [
		97728,
		7728
	],
	"./views/report/aged/wechat_whiteList.vue": [
		93945,
		3945
	],
	"./views/report/aged/weichat_SleepRadar.vue": [
		38340,
		8340
	],
	"./views/report/bigDate/aged_date.vue": [
		2439,
		2439
	],
	"./views/report/bigDate/aged_map.vue": [
		7710,
		7710
	],
	"./views/report/bigDate/anfang_map.vue": [
		38393,
		8393
	],
	"./views/report/bigDate/bed_map.vue": [
		87631,
		7631
	],
	"./views/report/bigDate/bed_transform.vue": [
		18857,
		8857
	],
	"./views/report/bigDate/chuangdian_map.vue": [
		7090,
		7090
	],
	"./views/report/bigDate/door_service.vue": [
		98329,
		8329
	],
	"./views/report/bigDate/fuwu_map.vue": [
		48980,
		8980
	],
	"./views/report/bigDate/health_record.vue": [
		92405,
		2405
	],
	"./views/report/bigDate/leidabo_map.vue": [
		29410,
		968,
		9410
	],
	"./views/report/bigDate/newShouhuan.vue": [
		91960,
		5449,
		1589,
		1960
	],
	"./views/report/bigDate/shengming_Radar.vue": [
		50381,
		381
	],
	"./views/report/bigDate/shouhuan_map.vue": [
		50752,
		5449,
		752
	],
	"./views/report/bigDate/yunxinxiongka.vue": [
		44554,
		1589,
		4554
	],
	"./views/report/pg/ability_assessment2022.vue": [
		54120,
		4120
	],
	"./views/report/pg/assessment2022.vue": [
		72648,
		2648
	],
	"./views/report/pg/assessment2022new.vue": [
		18937,
		8937
	],
	"./views/report/pg/assessment2025.vue": [
		97379,
		7379
	],
	"./views/report/pg/member_upd.vue": [
		81651,
		1651
	],
	"./views/report/pg/stay_assessment.vue": [
		78223,
		8223
	],
	"./views/report/report_aged_service_all.vue": [
		71212,
		1212
	],
	"./views/report/report_aged_service_count.vue": [
		965,
		965
	],
	"./views/report/report_aged_service_day.vue": [
		95329,
		5329
	],
	"./views/report/report_aged_service_money.vue": [
		82642,
		2642
	],
	"./views/report/report_aged_service_month.vue": [
		88272,
		8272
	],
	"./views/report/report_aged_service_project.vue": [
		37210,
		7210
	],
	"./views/report/report_aged_service_time.vue": [
		93414,
		3414
	],
	"./views/report/report_big_screen_1.vue": [
		44640,
		6567,
		4640
	],
	"./views/report/report_big_screen_10.vue": [
		85246,
		8612,
		5246
	],
	"./views/report/report_big_screen_100.vue": [
		25216,
		5216
	],
	"./views/report/report_big_screen_105.vue": [
		81760,
		1760
	],
	"./views/report/report_big_screen_14.vue": [
		19609,
		9609
	],
	"./views/report/report_big_screen_15.vue": [
		70993,
		8612,
		993
	],
	"./views/report/report_big_screen_2.vue": [
		79765,
		9765
	],
	"./views/report/report_big_screen_20.vue": [
		94863,
		4863
	],
	"./views/report/report_big_screen_200.vue": [
		37202,
		6567,
		7202
	],
	"./views/report/report_big_screen_201.vue": [
		30165,
		6567,
		165
	],
	"./views/report/report_big_screen_202.vue": [
		90290,
		6567,
		290
	],
	"./views/report/report_big_screen_21.vue": [
		38580,
		8580
	],
	"./views/report/report_big_screen_22.vue": [
		62448,
		2448
	],
	"./views/report/report_big_screen_23.vue": [
		51211,
		1211
	],
	"./views/report/report_big_screen_24.vue": [
		82049,
		2049
	],
	"./views/report/report_big_screen_25.vue": [
		36925,
		6925
	],
	"./views/report/report_big_screen_26.vue": [
		64937,
		4937
	],
	"./views/report/report_big_screen_27.vue": [
		2305,
		2305
	],
	"./views/report/report_big_screen_28.vue": [
		69225,
		9225
	],
	"./views/report/report_big_screen_29.vue": [
		28026,
		8026
	],
	"./views/report/report_big_screen_3.vue": [
		49020,
		6567,
		9020
	],
	"./views/report/report_big_screen_30.vue": [
		21582,
		1582
	],
	"./views/report/report_big_screen_4.vue": [
		59075,
		6567,
		9075
	],
	"./views/report/report_big_screen_50.vue": [
		69717,
		9717
	],
	"./views/report/report_big_screen_51.vue": [
		6565,
		6565
	],
	"./views/report/report_big_screen_52.vue": [
		67439,
		7439
	],
	"./views/report/report_big_screen_53.vue": [
		68324,
		8324
	],
	"./views/report/report_big_screen_54.vue": [
		61217,
		1217
	],
	"./views/report/report_big_screen_55.vue": [
		16783,
		6783
	],
	"./views/report/report_big_screen_56.vue": [
		4034,
		4034
	],
	"./views/report/report_big_screen_57.vue": [
		11675,
		1675
	],
	"./views/report/report_big_screen_58.vue": [
		44179,
		4179
	],
	"./views/report/report_big_screen_6.vue": [
		11625,
		1625
	],
	"./views/report/report_big_screen_60.vue": [
		46260,
		6260
	],
	"./views/report/report_big_screen_61.vue": [
		65260,
		5260
	],
	"./views/report/report_big_screen_80.vue": [
		8469,
		6567,
		8469
	],
	"./views/report/report_big_screen_81.vue": [
		66744,
		6567,
		6744
	],
	"./views/report/report_big_screen_82.vue": [
		38044,
		6567,
		8044
	],
	"./views/report/report_service_em_all.vue": [
		81853,
		1853
	],
	"./views/report/report_service_em_count.vue": [
		61630,
		1630
	],
	"./views/report/report_service_em_workhour.vue": [
		83568,
		3568
	],
	"./views/report/wx_report/report_1.vue": [
		20195,
		195
	],
	"./views/report/wx_report/report_2.vue": [
		41477,
		1477
	],
	"./views/report/wx_report/report_3.vue": [
		41112,
		1112
	],
	"./views/report/wx_report/report_4.vue": [
		26032,
		6032
	],
	"./views/report/xiangqing/aged_info.vue": [
		17495,
		7495
	],
	"./views/report/xiangqing/aged_shen_qing.vue": [
		31408,
		1408
	],
	"./views/report/xiangqing/big_aged.vue": [
		90119,
		119
	],
	"./views/report/xiangqing/big_gai_zhao.vue": [
		76778,
		6778
	],
	"./views/report/xiangqing/big_gai_zhao_ty.vue": [
		31764,
		1764
	],
	"./views/report/xiangqing/big_shang_men_fu_wu.vue": [
		12339,
		2339
	],
	"./views/report/xiangqing/di_bao.vue": [
		26762,
		6762
	],
	"./views/report/xiangqing/gao_ning.vue": [
		79896,
		9896
	],
	"./views/report/xiangqing/ji_gou_lie_biao.vue": [
		56930,
		6930
	],
	"./views/report/xiangqing/ji_gou_xiang_qing.vue": [
		6740,
		6740
	],
	"./views/report/yongai/big_screen_1.vue": [
		61029,
		6567,
		1029
	],
	"./views/report/yongai/ji_gou_lie_biao.vue": [
		11370,
		1370
	],
	"./views/report/yongai/ji_gou_xiang_qing.vue": [
		60140,
		140
	],
	"./views/robot/robot.vue": [
		61044,
		1044
	],
	"./views/robot/robot_patrol_record.vue": [
		3863,
		3863
	],
	"./views/scheduling/calendar.vue": [
		16174,
		6174
	],
	"./views/scheduling/grouping.vue": [
		48889,
		8889
	],
	"./views/scheduling/shift.vue": [
		49138,
		9138
	],
	"./views/screen/PersonSetting.vue": [
		26734,
		6734
	],
	"./views/screen/ProjectSetting.vue": [
		54358,
		4358
	],
	"./views/screen/ScreenShow.vue": [
		78069,
		8069
	],
	"./views/screen/index.vue": [
		11020,
		1020
	],
	"./views/smartScreen/smart_screen.vue": [
		72607,
		2607
	],
	"./views/stock/stock_product.vue": [
		46945,
		6945
	],
	"./views/stock/store_management.vue": [
		32826,
		2826
	],
	"./views/stock/warehousing.vue": [
		67687,
		7687
	],
	"./views/stock/warehousingChu.vue": [
		87585,
		7585
	],
	"./views/subsidy/subsidy_aged.vue": [
		70889,
		889
	],
	"./views/subsidy/subsidy_di.vue": [
		7419,
		7419
	],
	"./views/subsidy/subsidy_gao.vue": [
		32384,
		2384
	],
	"./views/supplement/supplementAged.vue": [
		85432,
		5432
	],
	"./views/supplement/supplementFood.vue": [
		9633,
		9633
	],
	"./views/supplement/supplementGoods.vue": [
		2256,
		2256
	],
	"./views/supplement/supplementLv.vue": [
		94511,
		4511
	],
	"./views/supplement/supplementST.vue": [
		71270,
		1270
	],
	"./views/supplyChain/contract.vue": [
		69227,
		9227
	],
	"./views/supplyChain/product.vue": [
		31889,
		1889
	],
	"./views/supplyChain/productCk.vue": [
		86780,
		6780
	],
	"./views/supplyChain/productNEW.vue": [
		11823,
		1823
	],
	"./views/supplyChain/purchaseProduct.vue": [
		38673,
		8673
	],
	"./views/supplyChain/purchaseRequisition.vue": [
		14792,
		4792
	],
	"./views/supplyChain/yachangjin.vue": [
		60970,
		970
	],
	"./views/supplyChain/yachangjinExcel.vue": [
		29316,
		6935
	],
	"./views/supplyChain/yaproductchuli.vue": [
		23813,
		3813
	],
	"./views/supplyChain/yaproductchuliOther.vue": [
		12982,
		2982
	],
	"./views/system/personal_project.vue": [
		83403,
		3403
	],
	"./views/system/project.vue": [
		78182,
		1527,
		8182
	],
	"./views/system/project_file.vue": [
		87073,
		7073
	],
	"./views/system/reform_project.vue": [
		37892,
		7892
	],
	"./views/system/role_manager.vue": [
		58394,
		8394
	],
	"./views/system/role_permission.vue": [
		65143,
		5143
	],
	"./views/system/user_manager.vue": [
		77370,
		7370
	],
	"./views/system/user_register.vue": [
		86161,
		6161
	],
	"./views/visiting/visiting_care.vue": [
		49991,
		9991
	],
	"./views/visiting/visiting_problem.vue": [
		43438,
		3438
	],
	"./views/visiting/visiting_record.vue": [
		15477,
		5477
	],
	"./views/vr/index.vue": [
		65733,
		2951,
		7825,
		5733
	],
	"./views/vr/simpleDemo.vue": [
		73,
		2951,
		73
	],
	"./views/vr/vrExhibition/config.vue": [
		99568,
		2951,
		7825,
		6511,
		699
	],
	"./views/vr/vrExhibition/index.vue": [
		64270,
		2951,
		4270
	],
	"./views/vr/vrExhibition/preview.vue": [
		21109,
		2951,
		7825,
		6511,
		4536
	],
	"./views/vr/vrExhibition/way.vue": [
		66016,
		2951,
		7825,
		6511,
		1307
	],
	"./views/vr/vrMarker/index.vue": [
		3,
		3
	],
	"./views/vr/vrScene/index.vue": [
		60532,
		2951,
		532
	],
	"./views/vr/vrScene/preview.vue": [
		89752,
		2951,
		9752
	],
	"./views/wechat/login.vue": [
		93773,
		6154
	],
	"./views/wechat/tfga/tfga.vue": [
		83100,
		3100
	],
	"./views/xingmai/xingmai.vue": [
		9568,
		9568
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85684;
module.exports = webpackAsyncContext;